<template>
  <div>
   <el-container>
  		<el-main>
  			<el-row :gutter="20">
		  		<el-col :span="24" :offset="6" :md="12">
		  			<div class="auth-header">
		  				<img src="../../assets/logo.png">
		  			</div>
		  			<div class="signup-body auth-panel">
		  			

             <h1 style="margin-top:0; padding-top:20px;">You're officially registered to transform! </h1>
             <h3 class="confirmation-details">The challenge starts soon. An email is coming with further instruction, but be prepared with the important dates below.  <br/><br/>
              User Dashboard Access - May 14th<br/>
              Before Photo Submission Period Opens - May 16th<br/>
              Challenge Officially Starts - May 21st
              Before Photo Submission & Registration Closes - June 8th<br/>
              Challenge End & After Photo Submission Opens - July 29th<br/><br/>
              More information to come via email soon. Now get ready, because the Challenge starts soon.<br/><br/>
              Any questions? Use the chat on the right hand side of the page, or access the FAQ <a target="_blank" href="https://faq.wodapalooza.com/transformation-challenge">here</a>.
              <br/><br/>
Last but not least, enjoy 30% off on WZA merch with the discount code:&nbsp;WZATCSPECIAL, just visit the <a href="https://store.wodapalooza.com/" target="_blank">WZA Store</a>
             </h3>
             <h4 style="color:#666;">Post this graphic to let others know you’re committed!</h4>
             <img style="width:100%" src="../../assets/ready.jpeg">
        
		  			</div>
		  		</el-col>
			</el-row>
  		</el-main>
	</el-container>
  </div>
</template>

<script>
import Steps from './steps';

export default {
  name: 'signup',
  components:{
    Steps
  },
  methods:{
    registerUser: function(){
      this.savingData = true;
      var _this = this;
      var user = new Parse.User();
      user.set("username", this.userData.email);
      user.set("email", this.userData.email);
      user.set("password",  this.userData.password);
      user.set("firstName", this.userData.firstName);
      user.set("lastName", this.userData.lastName);

      user.signUp(null, {
        success: function(user) {
          // Hooray! Let them use the app now.
           console.log("IT WORKED");
          console.log(user);
          _this.savingData = false;
          _this.$router.push('/signup/plan');
        },
        error: function(user, error) {
          console.log('EROR');
          this.savingData = false;
          console.log(error);
          // Show the error message somewhere and let the user try again.
          alert("Error: " + error.code + " " + error.message);
        }
      });
    }
  },
  data () {
    return {
      savingData: false,
      userData:{
        firstName:"",
        lastName:"",
        email:"",
        password:"",
        passwordConfirm:""
      },
      msg: 'Welcome to Your Vue.js App'
    };
  }
}
</script>

<style>
.confirmation-details {
  text-align: left;
  color: #666;
  font-weight: normal;
  line-height: 26px;
}
.confirmation-details a {
  color: #ef559a;
}
.auth-form {
  padding: 20px 0 0;
}
.auth-form .el-form-item{
  margin-bottom: 15px;
}
.auth-form label.el-form-item__label{
  width: 100%;
  padding: 0;
  line-height: 24px;
}

.auth-form button.el-button--primary{
  width: 100%;
  margin-top: 10px;
}
</style>
